import { Children, isValidElement, ReactNode } from "react";
import { TabPaneProps, TabPane } from "../TabPane";

/**
 * Gets the tab panes from the specified children.
 * @param children The children to get the tab panes from.
 * @returns The array of tab panes.
 */
export function getTabPanes(children: ReactNode | undefined): ReadonlyArray<TabPaneProps> {
  return (
    Children.map(children, (child) => {
      if (!isValidElement(child)) return null;
      if (child.type !== TabPane) {
        console.log("TabbedContainer ignoring unsupported child component.");
        return null;
      }
      return child.props;
    })?.filter((tabPane) => !!tabPane) ?? []
  );
}
